/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trial_Reminder_Title_1Inputs */

const en_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When should we remind you before your trial ends?`)
};

const ar_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متى تريد أن نذكّرك قبل انتهاء الفترة التجريبية؟`)
};

const de_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann möchten Sie vor Ablauf Ihrer Testphase erinnert werden?`)
};

const es_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuándo quieres que te recordemos que tu periodo de prueba está por terminar?`)
};

const fr_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand souhaitez-vous recevoir un rappel avant la fin de votre essai ?`)
};

const it_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando vuoi ricevere un promemoria prima della fine del periodo di prova?`)
};

const ja_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル終了の何日前にお知らせしますか？`)
};

const ko_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 체험 종료 며칠 전에 알려드릴까요?`)
};

const pt_br_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você quer receber um lembrete antes do fim do teste grátis?`)
};

const ru_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За сколько дней до окончания пробного периода вам напомнить?`)
};

const th_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณต้องการให้เราแจ้งเตือนก่อนช่วงทดลองใช้สิ้นสุดเมื่อไร?`)
};

const tr_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme süren sona ermeden ne kadar önce hatırlatılmak istersin?`)
};

const zh_cn_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体验快到期时，提前多久提醒你？`)
};

const zh_tw_trial_reminder_title_1 = /** @type {(inputs: Trial_Reminder_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費體驗快到期時，提前多久提醒你？`)
};

/**
* | output |
* | --- |
* | "When should we remind you before your trial ends?" |
*
* @param {Trial_Reminder_Title_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const trial_reminder_title_1 = /** @type {((inputs?: Trial_Reminder_Title_1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trial_Reminder_Title_1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trial_reminder_title_1(inputs)
	if (locale === "ar") return ar_trial_reminder_title_1(inputs)
	if (locale === "de") return de_trial_reminder_title_1(inputs)
	if (locale === "es") return es_trial_reminder_title_1(inputs)
	if (locale === "fr") return fr_trial_reminder_title_1(inputs)
	if (locale === "it") return it_trial_reminder_title_1(inputs)
	if (locale === "ja") return ja_trial_reminder_title_1(inputs)
	if (locale === "ko") return ko_trial_reminder_title_1(inputs)
	if (locale === "pt_br") return pt_br_trial_reminder_title_1(inputs)
	if (locale === "ru") return ru_trial_reminder_title_1(inputs)
	if (locale === "th") return th_trial_reminder_title_1(inputs)
	if (locale === "tr") return tr_trial_reminder_title_1(inputs)
	if (locale === "zh_cn") return zh_cn_trial_reminder_title_1(inputs)
	return zh_tw_trial_reminder_title_1(inputs)
});